import React from 'react';
import ReactDOM from 'react-dom/client';
import Application from './applications/Application';
import App from './applications/App';
import './services/Websockets';
import { reportError } from './services/Errors';
import Constants from './submodules/logictry_config/constants';

try {
  document.documentElement.style.colorScheme = Constants.isDarkMode ? 'dark' : 'light';
} catch (e) {
  // restricted document
}

// Polyfills
if (typeof globalThis === 'undefined') {
  window.globalThis = window;
}
if (typeof String.prototype.replaceAll == "undefined") {
  String.prototype.replaceAll = function(match, replace) {
    return this.replace(new RegExp(match, 'g'), () => replace);
  }
}
if (!Object.hasOwn) {
  Object.hasOwn = function(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}
if (!Object.values) {
  Object.values = function(obj) {
    return Object.keys(obj).map(function(key) {
      return obj[key];
    });
  };
}
// Polyfill for marked library
if (!String.prototype.at) {
  String.prototype.at = function (i) {
    i = Math.trunc(i) || 0;
    if (i < 0) i += this.length;
    if (i < 0 || i >= this.length) return undefined;
    return this[i];
  };
}
if (!Array.prototype.at) {
  Array.prototype.at = function (i) {
    i = Math.trunc(i) || 0;
    if (i < 0) i += this.length;
    if (i < 0 || i >= this.length) return undefined;
    return this[i];
  };
}
if (!Array.prototype.flatMap) {
  Array.prototype.flatMap = function (callback, thisArg) {
    if (this == null) throw new TypeError('Array.prototype.flatMap called on null or undefined');
    if (typeof callback !== 'function') throw new TypeError('callback must be a function');
    const source = Object(this);
    const length = Math.min(Math.max(Number(source.length) || 0, 0), Number.MAX_SAFE_INTEGER);
    const result = [];
    for (let index = 0; index < length; index += 1) {
      if (!(index in source)) continue;
      const mapped = callback.call(thisArg, source[index], index, source);
      if (Array.isArray(mapped)) {
        for (let innerIndex = 0; innerIndex < mapped.length; innerIndex += 1) {
          if (innerIndex in mapped) result.push(mapped[innerIndex]);
        }
      } else {
        result.push(mapped);
      }
    }
    return result;
  };
}

// Temporary error logging to find where the removeChild error is happening
let lastLogTime = 0;
const LOG_INTERVAL_MS = 5000;
const MAX_STRING_LENGTH = 5000;
const MAX_PARENT_LEVELS = 3;

const originalRemoveChild = Node.prototype.removeChild;

Node.prototype.removeChild = function (child) {
  // Check if child and parent match
  try {
    const now = Date.now();
    if (child?.parentNode !== this && (now - lastLogTime) > LOG_INTERVAL_MS) {
      lastLogTime = now;
      const getOutermostParent = (node) => {
        let current = node;
        let iteration = 0;
        while (current?.parentNode?.outerHTML && iteration < MAX_PARENT_LEVELS && current?.parentNode?.tagName !== 'BODY') {
          iteration += 1;
          current = current.parentNode;
        }
        try {
          return current?.outerHTML?.slice(0, MAX_STRING_LENGTH) || `[unrenderable outermost node]`; // truncate to avoid huge logs
        } catch {
          return `[unrenderable outermost node]`;
        }
      };
      const removeChildError = new Error(`Node removeChild called with wrong parent:

child:
${child?.outerHTML?.slice(0, MAX_STRING_LENGTH)}

child DOM hierarchy:
${getOutermostParent(child)}

correctParent:
${child?.parentNode?.outerHTML?.slice(0, MAX_STRING_LENGTH)}

correctParent DOM hierarchy:
${getOutermostParent(child?.parentNode)}

wrongParent:
${this?.outerHTML?.slice(0, MAX_STRING_LENGTH)}

wrongParent DOM hierarchy:
${getOutermostParent(this)}`);
      reportError(removeChildError.message, removeChildError.stack);
      return;
    }
  } catch (err) {
    const removeChildError = new Error(`Remove Child Fatal Error: ${err?.message}`);
    reportError(removeChildError.message, removeChildError.stack);
    return;
  }
  // If they do call the original removeChild
  return originalRemoveChild.call(this, child);
};


// Mount and render
const MOUNT_NODE = document.getElementById('root');
document.body.setAttribute('notranslate', true);
MOUNT_NODE.setAttribute('notranslate', true);
const render = () => {
  ReactDOM.createRoot(MOUNT_NODE).render(<Application><App /></Application>)
};
render();
